import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { isAdmin } from "@/lib/permissions";
import { settingsAdminItems, settingsPersonalItems } from "@/lib/navigation";

export function SettingsNav() {
  const { role } = useAuth();
  const location = useLocation();

  const linkClass = (path: string) => {
    const active = location.pathname === path;
    return `block px-3 py-2 rounded-lg text-sm whitespace-nowrap ${
      active ? "bg-emerald-50 text-emerald-700 font-medium" : "text-slate-600 hover:bg-slate-50"
    }`;
  };

  return (
    <div className="bg-white rounded-xl border border-slate-200 p-6">
      <nav className="space-y-1" aria-label="Settings">
        <p className="text-[10px] font-semibold uppercase tracking-wider text-slate-400 px-3 pb-1">Account</p>
        {settingsPersonalItems.map((item) => (
          <Link key={item.path} to={item.path} aria-current={location.pathname === item.path ? "page" : undefined} className={linkClass(item.path)}>
            {item.label}
          </Link>
        ))}
        {isAdmin(role) && (
          <>
            <p className="text-[10px] font-semibold uppercase tracking-wider text-slate-400 px-3 pb-1 pt-3">Organization</p>
            {settingsAdminItems.map((item) => (
              <Link key={item.path} to={item.path} aria-current={location.pathname === item.path ? "page" : undefined} className={linkClass(item.path)}>
                {item.label}
              </Link>
            ))}
          </>
        )}
      </nav>
    </div>
  );
}